import React from 'react';

function Features() {
    
    const features = [
        "Innovative Technology",
        "Robust Performance",
        "User friendly design",
        "Secure"
    ];

    return (
        <section>
            <h2>What to Expect</h2>
            {/*<ul>*/}
                {features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                ))}
            {/*</ul>*/}
        </section>
    );
}

export default Features;